export default {
  namespaced: true,
  state: {
    rdStation: {
      code: null,
      state: null,
    },
    pipeDrive: {
      code: null,
      state: null,
    },
  },
  getters: {},
  mutations: {
    SET_CODE_RDSTATION(state, payload) {
      state.rdStation.code = payload
    },
    SET_STATE_RDSTATION(state, payload) {
      state.rdStation.state = payload
    },
    SET_CODE_PIPEDRIVER(state, payload) {
      state.pipeDrive.code = payload
    },
    SET_STATE_PIPEDRIVER(state, payload) {
      state.pipeDrive.state = payload
    },

  },
  actions: {},
}
